module.exports = __webpack_public_path__ + "img/roadlist_marker.c218fb75.png";